var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShuttle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.2,
    y1: 10.2,
    x2: 8.2,
    y2: 5.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 6.1,
    cy: 16.6,
    r: 2.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.1,16.6H3.4c-0.9,0-1.6-0.7-1.6-1.6v-4.9V6.8c0-0.9,0.7-1.6,1.6-1.6h4.8h7.5h3.2c0.6,0,1.2,0.3,1.5,0.9 l1.7,3.2c0.1,0.2,0.2,0.5,0.2,0.8v0.1v2.4V15c0,0.9-0.7,1.6-1.6,1.6H20"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.6,
    y1: 16.6,
    x2: 8.2,
    y2: 16.6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "22.1,10.2 15.8,10.2 8.2,10.2 1.7,10.2  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.8,
    y1: 10.2,
    x2: 15.8,
    y2: 5.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 17.6,
    cy: 16.6,
    r: 2.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 22.1,
    y1: 12.6,
    x2: 21.1,
    y2: 12.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuttle);
export default __webpack_public_path__ + "static/media/shuttle.8589c5fe429d91e4ac7117f9ac253a25.svg";
export { ForwardRef as ReactComponent };